import { AvailabilitiesSearchBarComponent } from "./availabilities-search-bar/availabilities-search-bar.component";
import { AvailabilityFilterComponent } from "./availabilities-search-bar/filter/availability-filter.component";

export {
  AvailabilitiesSearchBarComponent,
  AvailabilityFilterComponent,
};

export const availabilitiesComponents = [
  AvailabilitiesSearchBarComponent,
  AvailabilityFilterComponent,
]
